module.exports = __webpack_public_path__ + "static/media/s12.3abe3408.png";